import { render, staticRenderFns } from "./cpt-scroll-table.vue?vue&type=template&id=3220be9c&scoped=true"
import script from "./cpt-scroll-table.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-table.vue?vue&type=script&lang=js"
import style0 from "./cpt-scroll-table.vue?vue&type=style&index=0&id=3220be9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220be9c",
  null
  
)

export default component.exports